/**
 * Responsive Submenu.
 * @format
 */

/* eslint-disable no-undef */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React from 'react';
import { useSwipeable } from 'react-swipeable';
import { useStateValue } from '@context/state-context';
import { safeUrl } from '@services/drupal-services';
import FeaturedMenuItem from '@components/featured-menu-item/featured-menu-item';
import ContextContactButton from '@forms/form-types/contact-form/context-contact-button';

/**
 * Parent Check.
 *
 * @param {string} tid
 */
const parentCheck = (tid: string): boolean => {
  let showButton = false;
  switch (tid) {
    case '29':
    case '30':
    case '31':
    case '32':
    case '73':
    case '74':
    case '75':
    case '76':
    case '77':
    case '78':
    case '296':
    case '612':
    case '728':
      showButton = true;
      break;
    default:
      showButton = false;
  }
  return showButton;
};

/**
 * Responsive Submenu.
 */
const ResponsiveSubmenu = (props): JSX.Element | null => {
  const { menuData, parent, title, featured } = props;
  const [{ menuItem, swipeToggle }, dispatch] = useStateValue();

  /**
   * Navigation Transition.
   *
   * @param {*} tid
   */
  const navigationTransition = (tid: string, transition = false): void => {
    const transitionDirection = tid === 'previous' ? 'backward' : 'forward';
    dispatch({
      type: 'navigating',
      setTransition: {
        transitioning: transition,
        direction: transitionDirection,
      },
    });

    if (transition) {
      setTimeout(() => {
        navigationTransition(tid);
      }, 400);
    }
  };

  /**
   * Update Navigation.
   *
   * @param {*} tid
   */
  const updateNavigation = (tid: string): void => {
    if (!swipeToggle.currentlySwiping) {
      const parentItem = tid === 'previous' ? null : menuItem.previous;
      const previousItem =
        tid === 'previous' ? menuItem.parent : menuItem.active;
      const activeItem = tid === 'previous' ? menuItem.previous : tid;

      dispatch({
        type: 'updateActive',
        makeActive: {
          previous: previousItem,
          active: activeItem,
          parent: parentItem,
        },
      });
      navigationTransition(tid, true);
    }
  };

  /**
   * Set Swipe.
   * @param {bool} swiping
   */
  const setSwiping = (swiping: boolean): void => {
    dispatch({
      type: 'swipingMenu',
      setSwipe: { currentlySwiping: swiping },
    });
  };

  /**
   * Swipe Handlers.
   */
  const swipeHandlers = useSwipeable({
    onSwipedRight: () => {
      updateNavigation('previous');
      setSwiping(true);
      setTimeout(() => {
        setSwiping(false);
      }, 300);
    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  /**
   * Submenu.
   * @returns
   */
  const submenu = menuData
    ? menuData.map((currentMenuItem) => {
        const {
          tid,
          name,
          link,
          new_window: newWindow,
          children,
          featured_description: description,
          featured_title: featuredTitle,
          featured_image: image,
          featured_link: featuredLink,
          featured_link_text: linkText,
        } = currentMenuItem;

        const hasSubmenu = children && children.length > 0 ? 'has-submenu' : '';
        const isActive =
          menuItem.active === tid || menuItem.previous === tid ? 'active' : '';
        const current = menuItem.active === tid ? 'current' : '';

        if (tid === '93') {
          return (
            <li key={tid} className={`parent-32`}>
              <ContextContactButton name="Contact Us" type="button" />
            </li>
          );
        }

        return (
          <li
            key={tid}
            className={`menu-item-${tid} ${isActive} ${current} parent-${parent} ${hasSubmenu}`}>
            {parentCheck(tid) ? (
              <button type="button" onClick={() => updateNavigation(tid)}>
                {name}
              </button>
            ) : (
              <a
                href={safeUrl(link)}
                target={newWindow === '0' ? '_self' : '_blank'}
                rel={newWindow === '0' ? '' : 'noreferrer noopener'}>
                {name}
              </a>
            )}
            <ResponsiveSubmenu
              menuData={children}
              parent={tid}
              title={name}
              featured={{
                description,
                featuredTitle,
                image,
                link: featuredLink,
                linkText,
              }}
            />
          </li>
        );
      })
    : null;

  /**
   * Render.
   */
  if (menuData) {
    return parentCheck(parent) ? (
      <div className="submenu" {...swipeHandlers}>
        <button
          type="button"
          className="back-button"
          onClick={() => updateNavigation('previous')}>
          Back
        </button>

        {/* Title */}
        {title && <h3 className="submenu-title">{title}</h3>}

        {/* Menu */}
        <ul>{submenu}</ul>

        {/* Featured Item */}
        {parent !== '29' && parent !== '30' && (
          <FeaturedMenuItem
            description={featured.description}
            title={featured.featuredTitle}
            image={featured.image}
            link={featured.link}
            linkText={featured.linkText}
          />
        )}
      </div>
    ) : (
      <ul>{submenu}</ul>
    );
  }
  return null;
};
export default ResponsiveSubmenu;
